import { render } from "./IsoVoyage.vue?vue&type=template&id=329ba61a"
import script from "./IsoVoyage.vue?vue&type=script&lang=js"
export * from "./IsoVoyage.vue?vue&type=script&lang=js"

import "./IsoVoyage.vue?vue&type=style&index=0&id=329ba61a&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__